import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDGift implements ICommand
{

	public ID : number = 0;
	public Price : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.ID = ba.readUint8();
		this.Price = ba.readUint53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.ID);
		ba.writeUint53(this.Price);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDGift();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'ID(B)='+this.ID+' ';
		str += 'Price(Q)='+this.Price+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'Gift';
	}

}
